export const loaderInstanse = (loader, flag = false) => {
    loader.setAttribute('data-loader', flag);
}

